import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { FlatList, View } from 'react-native'
import styled from 'styled-components'
import chunk from 'lodash/chunk'
import { H1, Text } from '../../../elements/typography'
import { media, useMediaBreakpoints } from '../../../style/media'
import { CloseUpListAd } from '../../ads/nativeAds/CloseUpListAd.js'
import { ArticleBlockBackgrounded, ArticleBlockGlowing } from '../components/ArticleBlock'
import messages from '../messages'

const StyledFlatList = styled(FlatList)`
  margin-bottom: ${(props) => props.theme.spacing.lg}px;
`

const PageHead = styled(View)`
  align-items: center;
  margin-top: ${(props) => props.theme.spacing.larger}px;
  margin-bottom: ${(props) => props.theme.spacing.large * 1.6}px;
`

const PageTitle = styled(H1)`
  font-size: ${(props) => props.theme.fontSizes.xxxlarge * 1.05}px;
  line-height: ${(props) => props.theme.fontSizes.xxxlarge * 1.05 * 1.1}px;
  text-align: center;
`

const TagLine = styled(Text)`
  text-align: center;
`

const ListRow = styled(View)`
  flex-direction: row;
`

const ListItem = styled(View)`
  padding: ${(props) => props.theme.spacing.sm}px;
  flex: 1 1 100%;
  ${media.sm`
    flex: 0 1 ${(props) => (props.doubleSize ? '100%' : '50%')};
  `};
  ${media.lg`
    flex: 0 1 ${(props) => (props.doubleSize ? '66.6666%' : '33.3333%')};
  `};
`

const ListHeaderComponent = () => (
  <PageHead>
    <PageTitle>
      <FormattedMessage {...messages.closeUpTitle} />
    </PageTitle>
    <TagLine>
      <FormattedMessage {...messages.closeUpTagLine} />
    </TagLine>
  </PageHead>
)

export const CloseUpArticlesList = ({
  articles = [],
  blogSlug,
  onArticleChosen,
  refreshing,
  onEndReached,
}) => {
  const { lg, sm } = useMediaBreakpoints()
  const articleRows = useMemo(() => {
    return lg
      ? [articles.slice(0, 2), ...chunk(articles.slice(2), 3)]
      : [articles.slice(0, 1), ...chunk(articles.slice(1), sm ? 2 : 1)]
  }, [articles, sm, lg])

  return (
    <StyledFlatList
      ListHeaderComponent={ListHeaderComponent}
      data={articleRows}
      keyExtractor={(item, index) => index.toString()}
      refreshing={refreshing}
      onEndReachedThreshold={1.5}
      onEndReached={onEndReached}
      renderItem={({ item, index }) => {
        const ArticleComponent = index < 2 ? ArticleBlockBackgrounded : ArticleBlockGlowing
        return (
          <ListRow style={{ justifyContent: index === 0 ? 'center' : 'flex-start' }}>
            {item.map((article) =>
              article.type === 'ad' ? (
                <ListItem key={article.placement}>
                  <CloseUpListAd
                    zone={article.zone}
                    placement={article.placement}
                    index={article.index}
                  />
                </ListItem>
              ) : (
                <ListItem key={article.slug} doubleSize={article.pinned}>
                  <ArticleComponent
                    article={article}
                    pinnedImgIsWide={sm}
                    onPress={onArticleChosen}
                    blogSlug={blogSlug}
                  />
                </ListItem>
              ),
            )}
          </ListRow>
        )
      }}
    />
  )
}
